import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5747ccb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nenhuma inscrição adicionada ainda", -1))
const _hoisted_2 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-20 ant-col-xl-21" }, null, -1))
const _hoisted_15 = { class: "ant-col ant-col-xs-4 ant-col-xl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_inscricoes_pessoa_modal = _resolveComponent("inscricoes-pessoa-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_table, {
        columns: _ctx.state.colunasGrade.filter(item => item.visible),
        "data-source": _ctx.computedInscricoespessoas,
        rowKey: "codigo",
        pagination: false,
        scroll: { y: 100},
        size: "small"
      }, {
        emptyText: _withCtx(() => [
          _hoisted_1
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column.key === 'acoes')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("a", {
                  class: "visualizar",
                  onClick: ($event: any) => (_ctx.editarInscricao(record))
                }, [
                  _createVNode(_component_icone, { nome: "editar" })
                ], 8, _hoisted_3),
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.confirmaExclusao(record)),
                  class: "excluir"
                }, [
                  _createVNode(_component_icone, { nome: "excluir" })
                ], 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          (column.key === 'TipoIE')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.obterDescricaoTipoIE(record.tipoIe)), 1))
            : (column.key === 'InscricaoEstadual')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(record.inscricaoEstadual), 1))
              : (column.key === 'InscricaoMunicipal')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(record.inscricaoMunicipal), 1))
                : (column.key === 'InscricaoSuframa')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(record.inscricaoSuframa), 1))
                  : (column.key === 'InscricaoTare')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(record.inscricaoTare), 1))
                    : (column.key === 'InscricaoAntt')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(record.inscricaoAntt), 1))
                      : (column.key === 'Principal')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                            (record.principal === true)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Principal"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_12, "Outras"))
                          ], 64))
                        : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
          style: {"margin-top":"5px","width":"100%"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.novaInscricao && _ctx.novaInscricao(...args)))
        }, "Nova Inscricao")
      ])
    ]),
    _createVNode(_component_inscricoes_pessoa_modal, {
      visivel: _ctx.state.exibirInscricaoModal,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirInscricaoModal) = $event)),
      inscricoes: _ctx.state.inscricaoSelecionada,
      empresas: _ctx.props.empresas,
      relacoes: _ctx.props.relacoes,
      onSalvarInscricoes: _ctx.salvarInscricoes
    }, null, 8, ["visivel", "inscricoes", "empresas", "relacoes", "onSalvarInscricoes"])
  ], 64))
}